import React from 'react';
import DriversTable from './DriversTable';

export default function AutoCalculateInstantEarningsDrivers() {
  return (
    <DriversTable title="Auto-calculate instant earnings" orderByChild="autoCalculateInstantEarnings" equalTo={true} />
  );
}
